import * as S from './elements'
import { theme } from '@components/gassan-ui'
import React, { AnchorHTMLAttributes, ButtonHTMLAttributes, FC } from 'react'
import { DisplayProps, SpaceProps, TypographyProps } from 'styled-system'

export type BaseLink = SpaceProps &
  TypographyProps &
  DisplayProps & {
    variant?: 'primary' | 'secondary' | 'tertiary'
  }

type AnchorType = BaseLink &
  AnchorHTMLAttributes<HTMLAnchorElement> & {
    type?: 'link'
  }

type ButtonType = BaseLink &
  ButtonHTMLAttributes<HTMLButtonElement> & {
    type?: 'button'
  }

type LinkType = AnchorType | ButtonType

export const colorVariants = {
  primary: theme.rolex.colors.primary,
  secondary: 'white',
  tertiary: theme.rolex.colors.shades[900],
}

export const Link: FC<BaseLink & LinkType> = React.forwardRef((props, ref: any) => {
  const { type, variant, children, ...rest } = props
  return (
    <S.Link as={type === 'button' ? 'button' : 'a'} variant={variant} ref={ref} {...rest}>
      {children}
    </S.Link>
  )
})

Link.defaultProps = {
  display: 'inline-flex',
}
